import {
  RECEIVING_ORDERS_INDEX_REQUESTED,
  RECEIVING_ORDERS_INDEX_SUCCESS,
  RECEIVING_ORDERS_INDEX_FAILURE,
  RECEIVING_ORDER_CREATE_REQUESTED,
  RECEIVING_ORDER_CREATE_SUCCESS,
  RECEIVING_ORDER_CREATE_FAILURE,
  RESET_NEW_PO,
} from '../types';

const INITIAL_STATE = {
  isFetching: false,
  status: 'waiting',
  receivingOrders: [],
  newReceivingOrder: null,
  errors: null
};

const receivingOrders = (state = INITIAL_STATE, action) => {
  const newState = { ...state };

  switch(action.type) {
    case RECEIVING_ORDERS_INDEX_REQUESTED:
      return Object.assign({}, state, {
        isFetching: true,
        receivingOrders: [],
        status: 'requesting',
        errors: null,
      });

    case RECEIVING_ORDERS_INDEX_SUCCESS:
      return Object.assign({}, state, {
        isFetching: false,
        status: 'success',
        receivingOrders: action.payload.warehouse_receiving_orders,
        errors: null
      });

    case RECEIVING_ORDERS_INDEX_FAILURE:
      return Object.assign({}, state, {
        isFetching: false,
        status: 'waiting',
        receivingOrders: [],
        errors: 'error here'
      });


    case RECEIVING_ORDER_CREATE_REQUESTED:
      newState.isFetching = true;
      newState.status = 'requesting';
      newState.newReceivingOrder = null;
      return newState;

    case RECEIVING_ORDER_CREATE_SUCCESS:
      newState.isFetching = false;
      newState.status = 'success';
      newState.newReceivingOrder = action.warehouseReceivingOrder.new_receiving_order;
      return newState;

    case RECEIVING_ORDER_CREATE_FAILURE:
      newState.isFetching = false;
      newState.status = 'error';
      newState.errors = 'error here';
      return newState;

    case RESET_NEW_PO:
      newState.newReceivingOrder = null;
      return newState;

    default:
      return state;
  }
}

export default receivingOrders;